/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Noblockdata2Inputs */

const zh_learn_noblockdata2 = /** @type {(inputs: Learn_Noblockdata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这条作答记录还没有保存任何题块数据。`)
};

const en_learn_noblockdata2 = /** @type {(inputs: Learn_Noblockdata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No block data recorded for this attempt.`)
};

const es_learn_noblockdata2 = /** @type {(inputs: Learn_Noblockdata2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay datos de bloques registrados para este intento.`)
};

/**
* | output |
* | --- |
* | "No block data recorded for this attempt." |
*
* @param {Learn_Noblockdata2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_noblockdata2 = /** @type {((inputs?: Learn_Noblockdata2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Noblockdata2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_noblockdata2(inputs)
	if (locale === "en") return en_learn_noblockdata2(inputs)
	return es_learn_noblockdata2(inputs)
});
export { learn_noblockdata2 as "learn_noBlockData" }